import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelection = () => {
    const [showOption, setShowOption] = useState(false);
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setShowOption(false);
    };

    // Get current language flag and text
    const currentLanguage = {
        en: {
            flag: "https://imgs.search.brave.com/hmqYLvERmcFW9RCxohSOfxXQWOeA3BLZjMsryPmSA7o/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzFhLzY5/Lzg3LzFhNjk4NzMx/Yjk2YzZhOWIyMDA5/MDVmOTM4ODc4ZWEx/LmpwZw",
            text: "English"
        },
        it: {
            flag: "https://imgs.search.brave.com/t75I9OP7qXsjqv33_jBrO0T1-9rQz3zK_ZSlSSrxhws/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJpdGFubmljYS5j/b20vNTkvMTc1OS0w/MDQtRjQxNzU0NjMv/RmxhZy1JdGFseS5q/cGc",
            text: "Italiano"
        }
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setShowOption(false);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <div className="relative group dropdown-container">
            <button
                className="inline-flex justify-center w-full sm:px-4 px-2 py-2 outline-none text-white bg-[#8B2433] border border-gray-300 rounded-full shadow-sm"
                onClick={() => setShowOption(!showOption)}
            >
                <span className="md:text-[16px] text-[13px] flex items-center gap-3 poppins-regular">
                    <img
                        src={currentLanguage[i18n.language]?.flag || currentLanguage.it.flag}
                        className="w-5 h-5 rounded-full"
                        alt="flag"
                    />{" "}
                    <span className="sm:block hidden">
                        {currentLanguage[i18n.language]?.text || currentLanguage.it.text}
                    </span>
                </span>
            </button>
            <div
                id="dropdown-menu"
                className={`${!showOption ? "hidden" : ""
                    } absolute right-0 mt-2 rounded-md shadow-lg bg-[#8B2433] text-white p-1 space-y-1 w-[120px] z-50`}
            >
                <div
                    onClick={() => changeLanguage('it')}
                    className="px-4 py-2 poppins-regular text-white hover:bg-gray-700 cursor-pointer rounded-md flex items-center gap-3"
                >
                    <img
                        src="https://imgs.search.brave.com/t75I9OP7qXsjqv33_jBrO0T1-9rQz3zK_ZSlSSrxhws/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJpdGFubmljYS5j/b20vNTkvMTc1OS0w/MDQtRjQxNzU0NjMv/RmxhZy1JdGFseS5q/cGc"
                        className="w-5 h-5 rounded-full"
                        alt="flag"
                    />{" "}
                    Italiano
                </div>
                <div
                    onClick={() => changeLanguage('en')}
                    className="px-4 py-2 poppins-regular text-white hover:bg-gray-700 cursor-pointer rounded-md flex items-center gap-3"
                >
                    <img
                        src="https://imgs.search.brave.com/hmqYLvERmcFW9RCxohSOfxXQWOeA3BLZjMsryPmSA7o/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzFhLzY5/Lzg3LzFhNjk4NzMx/Yjk2YzZhOWIyMDA5/MDVmOTM4ODc4ZWEx/LmpwZw"
                        className="w-5 h-5 rounded-full"
                        alt="flag"
                    />{" "}
                    English
                </div>
            </div>
        </div>
    );
}

export default LanguageSelection;




// LanguageSelection.jsx
// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const LanguageSelection = () => {
//     const { i18n } = useTranslation();

//     const changeLanguage = (event) => {
//         const selectedLanguage = event.target.value;
//         i18n.changeLanguage(selectedLanguage).catch(err => console.error(err));
//     };

//     return (
//         <div className="language_select">
//             <select onChange={changeLanguage} value={i18n.language}>
//                 <option value="en">English</option>
//                 <option value="it">Italian</option>
//             </select>
//         </div>
//     );
// };

// export default LanguageSelection;